module.exports = __webpack_public_path__ + "static/video_img_01-33e069120a1c4e7b3f416a93477c7aa0.png";